export const ActionType = {
  GET_CROPS: 'GET_CROPS',
  CREATE_CROP_DONE: 'CREATE_CROP_DONE',
  DELETE_CROP_DONE: 'DELETE_CROP_DONE',

  GET_STATES_LIST_DONE: 'GET_STATES_DONE',
  MERGE_CROPS: 'MERGE_CROPS',
  GET_BRANDINGS: 'GET_BRANDINGS',
  GET_DISCLAIMERS: 'GET_DISCLAIMERS',
  GET_LOGOS: 'GET_LOGOS',
  GET_PRODUCT_CATEGORIES_DONE: 'GET_PRODUCT_CATEGORIES_DONE',
  GET_SEED_CATEGORIES_DONE: 'GET_SEED_CATEGORIES_DONE',
  GET_SHELF_CATEGORIES_DONE: 'GET_SHELF_CATEGORIES_DONE',
  GET_SEED_CATEGORY_ATTRIBUTES_DONE: 'GET_SEED_CATEGORY_ATTRIBUTES_DONE',
  GET_SEEDS_DONE: 'GET_SEEDS_DONE',
  GET_SEED_ICONS_DONE: 'GET_SEED_ICONS_DONE',
  GET_TAGLINES: 'GET_TAGLINES',
  START_LOADING: 'START_LOADING',
  STOP_LOADING: 'STOP_LOADING',
  SAVE_DOCUMENT: 'SAVE_DOCUMENT',
  SAVE_PRODUCT_DONE: 'SAVE_PRODUCT_DONE',

  GET_DOCUMENT_LIST_DONE: 'GET_DOCUMENT_LIST_DONE',
  DELETE_DOCUMENT: 'DELETE_DOCUMENT',
  CLONE_DOCUMENT: 'CLONE_DOCUMENT',

  GET_PRODUCTS_DONE: 'GET_PRODUCTS_DONE',
  DELETE_PRODUCT_DONE: 'DELETE_PRODUCT_DONE',
  TOGGLE_PRODUCT_PUBLISH_DONE: 'TOGGLE_PRODUCT_PUBLISH_DONE',
  PRODUCT_UPDATE_DONE: `PRODUCT_UPDATE_DONE`,

  GET_ORDERS_LIST_DONE: 'GET_ORDERS_LIST_DONE',
  CREATE_ORDER_DONE: 'CREATE_ORDER_DONE',
  CREATE_ORDER_DISMISSED: 'CREATE_ORDER_DISMISSED',
  GET_ADMIN_ORDERS_LIST_DONE: 'GET_ADMIN_ORDERS_LIST_DONE',
  GET_ORDER_TYPE_COUNT: 'GET_ORDER_TYPE_COUNT',
  DECREMENT_ORDER_TYPE_COUNT: 'DECREMENT_ORDER_TYPE_COUNT',
  CHANGE_ORDER_STATUS_DONE: 'CHANGE_ORDER_STATUS_DONE',
  DELETE_ORDER: 'DELETE_ORDER',
  GET_ORDER_COST_REPORT_DONE: 'GET_ORDER_COST_REPORT_DONE',
  GET_ORDER_PLACED_REPORT_DONE: 'GET_ORDER_PLACED_REPORT_DONE',

  GET_PRODUCT_ICONS_DONE: 'GET_PRODUCT_ICONS_DONE',
  UPDATE_PRODUCT_ICON_DONE: 'UPDATE_PRODUCT_ICON_DONE',

  GET_PRODUCT_LOGOS_DONE: 'GET_PRODUCT_LOGOS_DONE',
  UPDATE_PRODUCT_LOGO_DONE: 'UPDATE_PRODUCT_LOGO_DONE',

  TOGGLE_CROP: 'TOGGLE_CROP',
  TOGGLE_BRANDING: 'TOGGLE_BRANDING',
  TOGGLE_LOGO: 'TOGGLE_LOGO',
  MOVE_CROP: 'MOVE_CROP',
  CHANGE_CROP_IMAGE: 'CHANGE_CROP_IMAGE',
  CHANGE_BRANDING: 'CHANGE_BRANDING',
  CHANGE_COVER_IMAGE: 'CHANGE_COVER_IMAGE',
  CHANGE_DOCUMENT_TITLE: 'CHANGE_DOCUMENT_TITLE',
  CHANGE_POSTCARD_IMAGE_FRONT: 'CHANGE_POSTCARD_IMAGE_FRONT',
  CHANGE_POSTCARD_IMAGE_BACK: 'CHANGE_POSTCARD_IMAGE_BACK',
  CHANGE_POSTER_IMAGE_BACKGROUND: 'CHANGE_POSTER_IMAGE_BACKGROUND',
  OPEN_DOCUMENT_DONE: 'OPEN_DOCUMENT_DONE',
  SAVE_DOCUMENT_DONE: 'SAVE_DOCUMENT_DONE',
  CREATE_DOCUMENT: 'CREATE_DOCUMENT',
  CHANGE_DOCUMENT_PAGES_COUNT: 'CHANGE_DOCUMENT_PAGES_COUNT',
  CHANGE_DOCUMENT_PAGES_COUNT_MULTI_LAYOUT: 'CHANGE_DOCUMENT_PAGES_COUNT_MULTI_LAYOUT',
  CHANGE_DOCUMENT_PAGES_COUNT_AGRONOMY_LAYOUT: 'CHANGE_DOCUMENT_PAGES_COUNT_AGRONOMY_LAYOUT',
  CHANGE_DOCUMENT_PAGES_COUNT_MIXED_LAYOUT: 'CHANGE_DOCUMENT_PAGES_COUNT_MIXED_LAYOUT',
  CHANGE_COMPANY_INFO: 'CHANGE_COMPANY_INFO',
  SKIP_STEP: 'SKIP_STEP',
  LOGGING_IN: 'LOGGING_IN',
  LOGGED_IN: 'LOGGED_IN',
  LOGGED_OUT: 'LOGGED_OUT',
  LOGIN_FAILED: 'LOGIN_FAILED',
  TOGGLE_CROP_PAGE_VIEW: 'TOGGLE_CROP_PAGE_VIEW',
  GET_PAGES_VIEW: 'GET_PAGES_VIEW',
  SET_DEFAULT_IMAGES: 'SET_DEFAULT_IMAGES',
  UPDATE_BRANDINGS: 'UPDATE_BRANDINGS',
  WRITE_SPREAD_TO_DOCUMENT: 'WRITE_SPREAD_TO_DOCUMENT',
  WRITE_PAGE_TO_DOCUMENT: 'WRITE_PAGE_TO_DOCUMENT',
  DRAG_N_DROP_PRODUCT: 'DRAG_N_DROP_PRODUCT',
  REMOVE_PRODUCT: 'REMOVE_PRODUCT',
  SETUP_WIZARD: 'SETUP_WIZARD',
  SET_NEW_PRODUCT_PRODUCT_TYPE: 'SET_NEW_PRODUCT_PRODUCT_TYPE',
  SET_NEW_PRODUCT_TEMPLATE_TYPE: 'SET_NEW_PRODUCT_TEMPLATE_TYPE',
  VALIDATE_PAGES_COUNT_VALUE: 'VALIDATE_PAGES_COUNT_VALUE',
  ON_SPREAD_SELECT_PAGE_RESULT: 'ON_SPREAD_SELECT_PAGE_RESULT',
  ON_PAGE_SELECT_PAGE_RESULT: 'ON_PAGE_SELECT_PAGE_RESULT',
  ON_PAGE_OR_SPREAD_SELECT: 'ON_PAGE_OR_SPREAD_SELECT',
  ON_ADD_PAGE_OR_SPREAD: 'ON_ADD_PAGE_OR_SPREAD',
  ON_REMOVE_PAGE: 'ON_REMOVE_PAGE',
  ON_REMOVE_SPREAD: 'ON_REMOVE_SPREAD',
  ON_REMOVE_PAGE_RESWITCH_EDITOR: 'ON_REMOVE_PAGE_RESWITCH_EDITOR',
  CHANGE_ZOOM: 'CHANGE_ZOOM',
  GET_ORDER_STATUSES_DONE: 'GET_ORDER_STATUSES_DONE',
  RESET_VALIDATIONS: 'RESET_VALIDATIONS',
  CHANGE_ADDITIONAL_INFO: 'CHANGE_ADDITIONAL_INFO',

  GET_COVER_IMAGES_DONE: 'GET_COVER_IMAGES_DONE',
  DELETE_COVER_IMAGE_DONE: 'DELETE_COVER_IMAGE_DONE',
  CREATE_COVER_IMAGE_DONE: 'CREATE_COVER_IMAGE_DONE',

  GET_AGRONOMY_REFERENCE_SHEETS_DONE: 'GET_AGRONOMY_REFERENCE_SHEETS_DONE',
  GET_PUBLISHED_AGRONOMY_REFERENCE_SHEETS_DONE: 'GET_PUBLISHED_AGRONOMY_REFERENCE_SHEETS_DONE',
  EDIT_AGRONOMY_REFERENCE_SHEET_DONE: 'EDIT_AGRONOMY_REFERENCE_SHEET_DONE',
  CREATE_AGRONOMY_REFERENCE_SHEET_DONE: 'CREATE_AGRONOMY_REFERENCE_SHEET_DONE',

  GET_BLANKS_DONE: 'GET_BLANKS_DONE',
  GET_PUBLISHED_BLANKS_DONE: 'GET_PUBLISHED_BLANKS_DONE',
  TOGGLE_BLANK_PUBLISH_DONE: 'TOGGLE_BLANK_PUBLISH_DONE',
  CREATE_BLANK_DONE: 'CREATE_BLANK_DONE',
  UPDATE_BLANK_DONE: 'UPDATE_BLANK_DONE',

  GET_TECH_SHEETS_DONE: 'GET_TECH_SHEETS_DONE',
  GET_PUBLISHED_TECH_SHEETS_DONE: 'GET_PUBLISHED_TECH_SHEETS_DONE',
  TOGGLE_TECH_SHEET_PUBLISH_DONE: 'TOGGLE_TECH_SHEET_PUBLISH_DONE',
  CREATE_TECH_SHEET_DONE: 'CREATE_TECH_SHEET_DONE',
  DELETE_ALL_TECH_SHEETS_DONE: 'DELETE_ALL_TECH_SHEETS_DONE',

  GET_CROP_DIVIDERS_DONE: 'GET_CROP_DIVIDERS_DONE',

  GET_SEED_DIVIDERS_DONE: 'GET_SEED_DIVIDERS_DONE',
  UPDATE_SEED_DIVIDER_DONE: 'UPDATE_SEED_DIVIDER_DONE',

  GET_SHELF_DIVIDERS_DONE: 'GET_SHELF_DIVIDERS_DONE',
  UPDATE_SHELF_DIVIDERS_DONE: 'UPDATE_SHELF_DIVIDERS_DONE',

  FINISH_LOADING_PDF: 'FINISH_LOADING_PDF',
  START_LOADING_PDF: 'START_LOADING_PDF',
  DELETE_PDF_FROM_DOWNLOAD: 'DELETE_PDF_FROM_DOWNLOAD',

  FINISH_LOADING_CSV: 'FINISH_LOADING_CSV',
  START_LOADING_DIV_COST_CSV: 'START_LOADING_DIV_COST_CSV',
  START_LOADING_ORDER_ANALYTICS_CSV: 'START_LOADING_ORDER_ANALYTICS_CSV',
  START_LOADING_PRODUCT_ANALYTICS_CSV: 'START_LOADING_PRODUCT_ANALYTICS_CSV',
  DELETE_CSV_FROM_DOWNLOAD: 'DELETE_CSV_FROM_DOWNLOAD',

  FINISH_LOADING_ZIP: 'FINISH_LOADING_ZIP',
  START_LOADING_ZIP: 'START_LOADING_ZIP',
  DELETE_ZIP_FROM_DOWNLOAD: 'DELETE_ZIP_FROM_DOWNLOAD',

  MOVE_THUMBNAIL: 'MOVE_THUMBNAIL',
  ON_MOVE_PLACEHOLDERS: 'ON_MOVE_PLACEHOLDERS',

  NAVIGATING: 'NAVIGATING',

  DELETE_BRANDING_DONE: 'DELETE_BRANDING_DONE',
  CREATE_BRANDING_DONE: 'CREATE_BRANDING_DONE',
  UPDATE_BRANDING_DONE: 'UPDATE_BRANDING_DONE',

  ARCHIVE_PRODUCT_LOGO_DONE: 'ARCHIVE_PRODUCT_LOGO_DONE',
  ARCHIVE_LOGO_DONE: 'ARCHIVE_LOGO_DONE',
  DELETE_LOGO_DONE: 'DELETE_LOGO_DONE',
  CREATE_LOGO_DONE: 'CREATE_LOGO_DONE',
  UPDATE_LOGO_DONE: 'UPDATE_LOGO_DONE',

  CREATE_DISCLAIMER_DONE: 'CREATE_DISCLAIMER_DONE',
  UPDATE_DISCLAIMER_DONE: 'UPDATE_DISCLAIMER_DONE',
  DELETE_DISCLAIMER_DONE: 'DELETE_DISCLAIMER_DONE',

  CREATE_SEED_ICON_DONE: 'CREATE_SEED_ICON_DONE',
  DELETE_SEED_ICON_DONE: 'DELETE_SEED_ICON_DONE',
  EDIT_SEED_ICON_DONE: 'EDIT_SEED_ICON_DONE',
  TOGGLE_SEED_ICON_PUBLISH_DONE: 'TOGGLE_SEED_ICON_PUBLISH_DONE',

  GET_FILLER_IMAGE_DONE: 'GET_FILLER_IMAGE_DONE',
  CREATE_FILLER_IMAGE_DONE: 'CREATE_FILLER_IMAGE_DONE',
  DELETE_FILLER_IMAGE_DONE: 'DELETE_FILLER_IMAGE_DONE',
  EDIT_FILLER_IMAGE_DONE: 'EDIT_FILLER_IMAGE_DONE',

  GET_POSTCARD_IMAGE_DONE: 'GET_POSTCARD_IMAGE_DONE',
  ARCHIVE_POSTCARD_IMAGE_DONE: 'ARCHIVE_POSTCARD_IMAGE_DONE',
  CREATE_POSTCARD_IMAGE_DONE: 'CREATE_POSTCARD_IMAGE_DONE',
  DELETE_POSTCARD_IMAGE_DONE: 'DELETE_POSTCARD_IMAGE_DONE',

  GET_POSTER_IMAGES_DONE: 'GET_POSTER_IMAGES_DONE',
  CREATE_POSTER_IMAGE_DONE: 'CREATE_POSTER_IMAGE_DONE',
  ARCHIVE_POSTER_IMAGE_DONE: 'ARCHIVE_POSTER_IMAGE_DONE',
  
  CREATE_TAGLINE_DONE: 'CREATE_TAGLINE_DONE',
  UPDATE_TAGLINE_DONE: 'UPDATE_TAGLINE_DONE',
  DELETE_TAGLINE_DONE: 'DELETE_TAGLINE_DONE',
};



// WEBPACK FOOTER //
// ./src/infrastructure/actionTypes.ts